// Point of Sale is enabled for all companies as of the 2026-07 rollout.
// This gate controls the whole POS surface: the sidebar nav item, the
// /purchases/point-of-sale routes, the "Send to POS" buttons, and the
// in-progress payment drawer. It stays as the single chokepoint so the
// surface can be re-restricted from one place if ever needed.

/**
 * True when the signed-in company can see the POS surface. Open to
 * everyone since the general rollout; formerly an allowlist of beta
 * company ids.
 */
export function isPosBetaCompany() {
  return true;
}

/**
 * True when the signed-in user can manage the POS surface: the company
 * gate above plus the payment_pages_configure permission (read from the
 * localStorage permissions list users-me sets at login; admins get the
 * key in that list, so no separate role check is needed). Used by the
 * POS route guards and Send to POS button so visibility matches what
 * the POS endpoints actually enforce.
 */
export function canConfigurePos() {
  return hasAnyPermission(['payment_pages_configure']);
}

/**
 * True when the signed-in user can send orders to POS devices and track
 * or cancel in-flight POS payments. Operational, not configuration:
 * payments_update ("Create and update payments") covers it, and POS
 * configurators keep access too. Mirrors the server-side gate on
 * pos-send-order / cancel / list sessions. Used by SendToPosButton and
 * the in-progress payment drawer.
 */
export function canSendToPos() {
  return hasAnyPermission(['payments_update', 'payment_pages_configure']);
}

function hasAnyPermission(types) {
  if (!isPosBetaCompany()) return false;
  try {
    const permissions = JSON.parse(localStorage.getItem('permissions'));
    return !!permissions && permissions.some((p) => types.includes(p));
  } catch (e) {
    return false;
  }
}
